<template>
  <div class="content">
    <h1 class="is-hidden">Pin- und Steckerbelegungen</h1>
    <div class="box">
      <h2 class="has-text-centered">Pins</h2>
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'pins-raspberry-pi'}" class="inherited">
                  <div class="p-2">
                    Raspberry Pi
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'pins-arduino-mega'}" class="inherited">
                  <div class="p-2">
                    Arduino Mega
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'pins-arduino-micro'}" class="inherited">
                  <div class="p-2">
                    Arduino Micro
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'pins-arduino-uno'}" class="inherited">
                  <div class="p-2">
                    Arduino Uno
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'pins-arduino-nano'}" class="inherited">
                  <div class="p-2">
                    Arduino Nano
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'pins-arduino-due'}" class="inherited">
                  <div class="p-2">
                    Arduino Due
                  </div>
                </router-link>
              </td>
            </tr>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'pins-arduino-leonardo'}" class="inherited">
                  <div class="p-2">
                    Arduino Leonardo
                  </div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="box">
      <h2 class="has-text-centered">Stecker</h2>
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped has-text-centered">
          <tbody>
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'pins-usb'}" class="inherited">
                  <div class="p-2">
                    USB 3.0
                  </div>
                </router-link>
              </td>
            </tr>
            <!--
            <tr class="is-clickable">
              <td>Ethernet (RJ45) (in Arbeit)</td>
            </tr>
            <tr class="is-clickable">
              <td>SCART <i>(in Arbeit)</i></td>
            </tr>
            <tr class="is-clickable">
              <td>HDMI <i>(in Arbeit)</i></td>
            </tr>
            !-->
            <tr class="is-clickable">
              <td class="p-0">
                <router-link :to="{name: 'pins-vga'}" class="inherited">
                  <div class="p-2">
                    VGA
                  </div>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ee-pins',
  metaInfo: {
    title: 'Pins und Steckerbelegungen | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Sammlung verschiedener Pin- und Steckerbelegungen (Raspberry, Arduino, USB, Ethernet, ...).'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Pin- und Steckerbelegungen', route: 'start' })
  }
}
</script>
